export function mapEnumToOptions<T extends Record<string, string>>(enumObject: T) {
  return Object.entries(enumObject).map(([key, value]) => ({
    label: value,
    value: key,
  }));
}
